import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { PARENT_NAV } from "./ParentDashboard";
import api from "@/lib/api";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function Orders() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/orders").then((r) => setItems(r.data)); }, []);
  const downloadInvoice = (o) => {
    const lines = [
      `SchoolLane Invoice`,
      `Order: ${o.order_number}`,
      `Student: ${o.student_name} (Class ${o.student_class})`,
      `Address: ${o.delivery_address}`,
      ``,
      ...o.items.map((i) => `- ${i.name} x ${i.qty} = ₹${(i.price * i.qty).toLocaleString('en-IN')}`),
      ``,
      `Total: ₹${Number(o.total).toLocaleString('en-IN')}`,
      `Payment: ${o.payment_status}`,
    ];
    const url = URL.createObjectURL(new Blob([lines.join("\n")], { type: "text/plain" }));
    const a = document.createElement("a"); a.href = url; a.download = `${o.order_number}.txt`; a.click();
    toast.success("Invoice downloaded");
  };
  return (
    <DashboardLayout nav={PARENT_NAV} title="My Orders">
      <div className="space-y-4">
        {items.map((o) => (
          <div key={o.id} className="sl-card p-5" data-testid={`order-${o.id}`}>
            <div className="flex flex-wrap justify-between gap-3">
              <div>
                <div className="font-semibold text-slate-900">{o.order_number}</div>
                <div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString('en-IN')}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs px-2 py-1 rounded-full bg-amber-50 text-amber-700 capitalize">{o.delivery_status}</span>
                <div className="font-bold">₹{Number(o.total).toLocaleString('en-IN')}</div>
                <button onClick={() => downloadInvoice(o)} data-testid={`inv-${o.id}`} className="inline-flex items-center gap-1 text-brand-blue text-sm font-semibold"><Download size={14} /> Invoice</button>
              </div>
            </div>
            <div className="mt-3 border-t border-slate-100 pt-3 text-sm text-slate-600">
              {o.items.map((i) => <div key={`${o.id}-${i.product_id || i.name}`}>{i.qty}× {i.name} <span className="text-slate-400">— ₹{(i.price * i.qty).toLocaleString('en-IN')}</span></div>)}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="sl-card p-8 text-center text-slate-500">You haven't placed any orders yet.</div>}
      </div>
    </DashboardLayout>
  );
}
